export default "__VITE_ASSET__d764ca14__"